import React, { useEffect, useState } from 'react';
import {
  GET_DOCUMENT_LIST_ENDPOINT,
  ADD_DOCUMENT_ENDPOINT
} from '../../../config/api';

function DocumentTab({ documents = [], setDocuments }) {
  const [docList, setDocList] = useState([]);
  const [showAddInput, setShowAddInput] = useState(false);
  const [newDocName, setNewDocName] = useState('');

  const fetchDocs = async () => {
    try {
      const res = await fetch(GET_DOCUMENT_LIST_ENDPOINT);
      const data = await res.json();
      if (data.success && Array.isArray(data.documents)) {
        const merged = data.documents.map(doc => {
          const existing = documents.find(d => d.document_name === doc.document_name);
          return {
            ...doc,
            mandatory: existing?.mandatory || false
          };
        });
        setDocList(merged);
      }
    } catch (err) {
      console.error("Error fetching document list", err);
    }
  };

  useEffect(() => {
    fetchDocs();
  }, []);

  const toggleMandatory = (index) => {
    const updated = [...docList];
    updated[index].mandatory = !updated[index].mandatory;
    setDocList(updated);
    setDocuments(updated.filter(doc => doc.mandatory));
  };

  const handleAddDocument = async () => {
    if (!newDocName.trim()) {
      alert("Please enter document name");
      return;
    }

    try {
      const res = await fetch(ADD_DOCUMENT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ document_name: newDocName.trim() })
      });

      const data = await res.json();
      if (data.success) {
        alert("Document added successfully");
        setNewDocName('');
        setShowAddInput(false);
        fetchDocs(); // refresh list
      } else {
        alert(data.error || "Failed to add document");
      }
    } catch (err) {
      console.error("Add document error:", err);
      alert("Server error while adding document");
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped">
        <caption className="text-muted">
          Select mandatory documents for this account. This will help dispatch team in their checklist.
        </caption>
        <thead className="table-light">
          <tr>
            <th>Document Name</th>
            <th style={{ width: '150px' }}>Mandatory</th>
          </tr>
        </thead>
        <tbody>
          {docList.map((doc, index) => (
            <tr key={doc.id}>
              <td>{doc.document_name}</td>
              <td className="text-center">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={doc.mandatory}
                  onChange={() => toggleMandatory(index)}
                  id={`doc-${doc.id}`}
                />
              </td>
            </tr>
          ))}
          {docList.length === 0 && (
            <tr>
              <td colSpan="2" className="text-center text-muted">No documents found</td>
            </tr>
          )}
        </tbody>
      </table>

      {!showAddInput && (
        <button
          className="btn btn-outline-primary mt-3"
          onClick={() => setShowAddInput(true)}
        >
          ➕ Add New Document
        </button>
      )}

      {showAddInput && (
        <div className="mt-3">
          <input
            type="text"
            className="form-control d-inline-block w-50 me-2"
            placeholder="Enter new document name"
            value={newDocName}
            onChange={(e) => setNewDocName(e.target.value)}
          />
          <button className="btn btn-success me-2" onClick={handleAddDocument}>Save</button>
          <button className="btn btn-secondary" onClick={() => {
            setNewDocName('');
            setShowAddInput(false);
          }}>Cancel</button>
        </div>
      )}
    </div>
  );
}

export default DocumentTab;
